<template>
  <drop
    :style="{
      visibility: alwaysShow || draggingComponent ? 'visible' : 'hidden'
    }"
    class="drop border pb-2 pr-2 rounded mt-1 mb-1 border-dashed"
    :class="over ? 'border-success bg-light-success' : 'border-med-light-gray'"
    @dragover="over = true"
    @dragleave="over = false"
    @drop="handleDrop"
  >
    <slot></slot>
  </drop>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "FormBuilderElementDropArea",
  props: ["alwaysShow", "formId"],
  data: function() {
    return { over: false };
  },
  methods: {
    ...mapMutations("formBuilder", [
      "deleteFormBuilderMovingComponent",
      "setFormBuilderDragging"
    ]),
    handleDrop(data) {
      this.deleteFormBuilderMovingComponent({ formId: this.formId });
      this.$emit("handle-drop", data);
      this.setFormBuilderDragging({ dragging: false, formId: this.formId });
      this.over = false;
    }
  },
  computed: {
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    draggingComponent() {
      return this.forms[this.formId].draggingComponent;
    }
  }
};
</script>
<style scoped>
.border-dashed {
  border-style: dashed !important;
}
.bg-light-success {
  background-color: lightgreen;
}
</style>
